import { render, staticRenderFns } from "./AssistantCatHomeStage.vue?vue&type=template&id=45848e8d&scoped=true"
import script from "./AssistantCatHomeStage.vue?vue&type=script&lang=ts"
export * from "./AssistantCatHomeStage.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatHomeStage.vue?vue&type=style&index=0&id=45848e8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45848e8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45848e8d')) {
      api.createRecord('45848e8d', component.options)
    } else {
      api.reload('45848e8d', component.options)
    }
    module.hot.accept("./AssistantCatHomeStage.vue?vue&type=template&id=45848e8d&scoped=true", function () {
      api.rerender('45848e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/assistantCatHome/AssistantCatHomeStage.vue"
export default component.exports